import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function YtMartesBenefits() {
  const benefits = ['Principios para diseñar productos digitales utilizando herramientas de IA', 'Un marco conceptual sobre cómo funcionan los procesos de venta digital', 'Cómo entender este modelo incluso si no tienes experiencia previa', 'Ejemplos de cómo la IA puede apoyar tareas creativas y organizativas'];
  const notRequired = ['Experiencia previa en negocios digitales', 'Conocimientos técnicos avanzados', 'Una gran inversión inicial'];
  return <section data-id="element-1004">
      <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-1005">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-10 text-center leading-tight" data-id="element-1006">
          Lo que se abordará en la masterclass:
        </h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 max-w-5xl mx-auto" data-id="element-1007">
          <div data-id="element-1008">
            <div className="flex items-center justify-center mb-6" data-id="element-1009">
              <div className="bg-red-600 bg-opacity-20 rounded-full p-3" data-id="element-1010">
                <XIcon className="h-8 w-8 text-red-500" data-id="element-1011" />
              </div>
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-6 text-center text-red-400" data-id="element-1012">
              No necesitas:
            </h3>
            <ul className="space-y-4" data-id="element-1013">
              {notRequired.map((item, index) => <li key={index} className="flex items-start" data-id="element-1014">
                  <XIcon className="h-6 w-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-1015" />
                  <span className="text-base md:text-lg leading-relaxed" data-id="element-1016">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-1017">
            <div className="flex items-center justify-center mb-6" data-id="element-1018">
              <div className="bg-green-600 bg-opacity-20 rounded-full p-3" data-id="element-1019">
                <CheckIcon className="h-8 w-8 text-green-500" data-id="element-1020" />
              </div>
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-6 text-center text-green-400" data-id="element-1021">
              Contenido educativo:
            </h3>
            <ul className="space-y-4" data-id="element-1022">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-1023">
                  <CheckIcon className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-1024" />
                  <span className="text-base md:text-lg leading-relaxed" data-id="element-1025">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700" data-id="element-1026">
          <p className="text-base md:text-lg text-center text-gray-300 leading-relaxed mb-4" data-id="element-1027">
            Esta masterclass tiene fines educativos. No se trata de una promesa
            de resultados ni de ingresos, sino de una explicación del modelo y
            los procesos involucrados.
          </p>
        </div>
      </div>
    </section>;
}